import React from "react";
import InteractionsSummary from "./components/InteractionsSummary";
import InteractionsBar from "./components/InteractionsBar";

function InteractionsGroup({ post, desktopCommentInputRef, mobileCommentInputRef, viewPost }) {
  return (
    <div className="interactions-group-wrapper">
      <InteractionsSummary post={post} />
      <InteractionsBar
        post={post}
        desktopCommentInputRef={desktopCommentInputRef}
        mobileCommentInputRef={mobileCommentInputRef}
        viewPost={viewPost}
      />
    </div>
  );
}

export default InteractionsGroup;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/InteractionsGroup/index.js